export default {
  path: 'help_center_pc',
  component: () => import('./view'),
  meta: {
    auth: true
  }
}
